import React from 'react';
import './about.css';
import img1 from '../../../About/Picture2.png';
import img2 from '../../../About/Picture1.png';
import img3 from '../../../About/Picture3.png';
import img4 from '../../../About/picture4.jpg';
import img5 from '../../../About/picture5.png';

const About = () => {
    return (
        <section className='about-section'>
            <div className='about-header'>
                <div className='about-header-bg'>
                </div>
                <div >
                    <div className='about-head-div'>
                        <h1 className='about-text-style'>About Us</h1>
                        <span>
                            <h3 className='about-text-style-2'>We are a dynamic and results-driven <br /> 360 marketing agency dedicated <br /> to propelling your business to <br /> new heights in the digital age.</h3>
                        </span>
                    </div>
                </div>
            </div>
            <div className='py-20' style={{ backgroundColor: '#2e0721' }}>
                <div className='grid grid-cols-1 lg:grid-cols-3'>
                    <div className="card w-96 ">
                        <figure className="px-10 pt-10">
                            <img src={img1} alt="Shoes" className="" />
                        </figure>
                        <div className="card-body items-center text-center text-white">
                            <h2 className="card-title">Newaz Mahtab</h2>
                            <p className='font-bold'>Chairman</p>
                            <p className='text-start'>A passionate entrepreneur, industrialist &
                                singer, songwriter with a Marketing
                                degree from IBA. He started his career as
                                the marketing and sales director in his
                                family owned business Moushumi
                                Industries LTD (Cute) and went on
                                dynamically to successfully establish
                                more businesses including Bowling
                                Footwear (Founder Chairman), Goodlife
                                Pharmaceuticals ( Co Founder),
                                RainCloud (Co Founder) and Boatman
                                Films (Founder). With over 12 years of
                                professional experience, Newaz Mahtab
                                believes in innovation and strategic
                                planning as the key to success.
                            </p>

                        </div>
                    </div>
                    <div className="card w-96 ">
                        <figure className="px-10 pt-10">
                            <img src={img2} alt="Shoes" className="" />
                        </figure>
                        <div className="card-body items-center text-center text-white">
                            <h2 className="card-title">Chowdhury Abir Ashraf</h2>
                            <p className='font-bold'>Co-founder</p>
                            <p className='text-start'>After finishing his studies in the UK, He’s worked with one of the top minds of the industry. He came back to Bangladesh believing it was time to give back. He has been involved with many Socialworks while he was the CEO of Positive Hub 360, an infamous marketing and media agency where he partnered up with on of our top music composer FuadAl Muktadir. Now he co-founded Rain Cloud Digital with the vision of bringing in innovation to advertising and making a workplace for the young, creative minds.
                            </p>

                        </div>
                    </div>
                    <div className="card w-96 ">
                        <figure className="px-10 pt-10">
                            <img src={img3} alt="Shoes" className="" />
                        </figure>
                        <div className="card-body items-center text-center text-white">
                            <h2 className="card-title">Nabil Ashraf Chowdhury </h2>
                            <p className='font-bold'>Partner, Head Planning and Content</p>
                            <p className='text-start'>Let’s say he is the creative guy who’ll take up the challenge to make a project, brand or company and go over the roof. With years of experience working in a number of Marketing agencies and serving clients like GSK, Microsoft, Ford, etc. he has been the mastermind behind numerous ingenious marketing campaigns.
                            </p>

                        </div>
                    </div>
                    <div className="card w-96 lg:ml-60">
                        <figure className="px-10 pt-10">
                            <img src={img4} alt="Shoes" className="w-[304px] h-[303.25px]" />
                        </figure>
                        <div className="card-body items-center text-center text-white">
                            <h2 className="card-title">MD Ratib Reza</h2>
                            <p className='font-bold'>Head of HR, Admin and Accounts</p>
                            <p className='text-start'>As the latest member of the board, he joined Raincloud Communications in 2019. With years of experience working with major companies and top brands such as Homebound Logistics, Aamra Group, MGI, PRAN Frooto, Fresh Cement etc; he is overseeing multiple aspects of the company. He also holds a directorial position at R. R. Hospital, Sylhet.
                            </p>

                        </div>
                    </div>
                    <div className="card w-96 lg:ml-60">
                        <figure className="px-10 pt-10">
                            <img src={img5} alt="Shoes" className="" />
                        </figure>
                        <div className="card-body items-center text-center text-white">
                            <h2 className="card-title">Imtiaz Mahtab</h2>
                            <p className='font-bold'>Partner</p>
                            <p className='text-start'>A passionate entrepreneur, industrialist &
                                singer, songwriter with a Marketing
                                degree from IBA. He started his career as
                                the marketing and sales director in his
                                family owned business Moushumi
                                Industries LTD (Cute) and went on
                                dynamically to successfully establish
                                more businesses including Bowling
                                Footwear (Founder Chairman), Goodlife
                                Pharmaceuticals ( Co Founder),
                                RainCloud (Co Founder) and Boatman
                                Films (Founder).
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='about-last-div'>
                <div className='about-last-div-bg'>
                </div>
                <div >
                    <div className='about-last-div-text'>
                        <p className='about-paragraph'>A TRUE PARTNERSHIP</p>
                        <h1 className='about-last-text'>Our client list speaks for itself sed <br /> non mauris vitae erat consequat <br /> auctor eu in elit class aptent.</h1>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;